import React, { useEffect, useState } from "react";
import { getIsTourShownFirstTime } from "./helpers/getIsTourWasShown.js";
import ProductTour from "./ProductTour.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import TakeTourFloatingButton from "./components/TakeTourFloatingButton.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";

/**
 * Find a name and ID for the tour
 * Check is the tour already shown
 * Add "Take a tour" floating button to the page
 * */

const ProductTourWrapper = ({ isPageReady = true }) => {
  const { getCurrentPage } = useContent();
  const { getUserData, isLoggedIn } = useUser();
  const { desktopCondition } = useMediaQueries();

  // Make a tour name based on current page name
  const tourName = getCurrentPage();
  // Make a tour ID which consist of tour name and current user ID
  const tourID = isLoggedIn() ? `tour-${tourName}-${getUserData().UserId}` : "";

  // Check if current tourID already exist within local storage
  const [isShownFirstTime, setIsShownFirstTime] = useState(false);

  useEffect(() => {
    // users where complaining about annoying behavior of the product tour 
    // so, we decided to show it only on the product tour button click
    
    // setIsShownFirstTime(getIsTourShownFirstTime(tourID));
    setIsShownFirstTime(false);
  }, [tourID]);

  // Show tour only for the desktop
  if (!desktopCondition) return null;

  //TODO: implement tours for mobile and tablets

  return (
    isPageReady &&
    tourName &&
    isLoggedIn() && (
      <>
        <TakeTourFloatingButton
          setIsShownFirstTime={setIsShownFirstTime}
          tourName={tourName}
        />
        {isShownFirstTime && (
          <ProductTour
            tourName={tourName}
            tourID={tourID}
            setIsShownFirstTime={setIsShownFirstTime}
          />
        )}
      </>
    )
  );
};

export default ProductTourWrapper;
